import {fromJS} from 'immutable';

export function immutableFactory<T extends {[key: string]: any}>(
  arg: T,
): ImmutableMap<T> {
  return fromJS(arg) as any;
}
